interface HourGroupingProps {
  hour: number
  isFirstInGroup: boolean
}

interface TimeGroup {
  name: string
  icon: string
  color: string
  bgColor: string
  textColor: string
}

const getTimeGroup = (hour: number): TimeGroup => {
  if (hour >= 0 && hour <= 5) {
    return {
      name: 'Early Morning',
      icon: '🌙',
      color: 'from-indigo-500/20 to-purple-500/20',
      bgColor: 'bg-indigo-50/50',
      textColor: 'text-indigo-700',
    }
  } else if (hour >= 6 && hour <= 11) {
    return {
      name: 'Morning',
      icon: '🌅',
      color: 'from-amber-500/20 to-orange-500/20',
      bgColor: 'bg-amber-50/50',
      textColor: 'text-amber-700',
    }
  } else if (hour >= 12 && hour <= 17) {
    return {
      name: 'Afternoon',
      icon: '☀️',
      color: 'from-yellow-500/20 to-amber-500/20',
      bgColor: 'bg-yellow-50/50',
      textColor: 'text-yellow-700',
    }
  } else {
    return {
      name: 'Evening',
      icon: '🌆',
      color: 'from-blue-500/20 to-indigo-500/20',
      bgColor: 'bg-blue-50/50',
      textColor: 'text-blue-700',
    }
  }
}

export function HourGrouping({ hour, isFirstInGroup }: HourGroupingProps) {
  if (!isFirstInGroup) return null

  const group = getTimeGroup(hour)

  return (
    <div className={`col-span-8 border-b border-slate-200/60 ${group.bgColor} relative`}>
      {/* Gradient line */}
      <div className={`bg-linear-to-r h-1 ${group.color} relative`}>
        <div className="bg-linear-to-r absolute inset-0 from-transparent via-white/30 to-transparent"></div>
      </div>

      {/* Group label */}
      <div className="flex items-center gap-3 p-3">
        <div className="flex items-center gap-2">
          <span className="text-lg">{group.icon}</span>
          <span className={`text-sm font-medium ${group.textColor}`}>{group.name}</span>
        </div>

        {/* Decorative dots */}
        <div className="flex flex-1 items-center">
          <div className="ml-4 flex gap-1">
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className={`h-1 w-1 rounded-full ${group.textColor.replace('text-', 'bg-')}/40`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
